<template>
  <div class="app-content auth">
    <Navbar />
    <div class>
      <div class="text-white px-5 md:px-0 mt-10">
        <div class="text-center w-full md:w-1/2 mx-auto">
          <h1
            class="text-2xl md:text-5xl mb-5 md:mb-0 leading-none font-bold space-x-1"
          >
            <span class="text-custom">User Login</span>
          </h1>
        </div>

        <div class="md:-ml-20 mt-3 text-left">
          <div class="text-xl mx-auto text max-w-2xl py-4 md:px-4">
            <div
              class="w-full md:flex justify-end items-center font-medium p-2 md:mb-5"
            >
              <span class="text-white mr-3">Email:</span>
              <input
                type="text"
                class="focus:outline-none w-full md:w-3/4 text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-full px-5"
                placeholder="Enter email here"
                v-model="email"
              />
            </div>
            <div
              class="w-full md:flex justify-end items-center font-medium p-2 md:mb-5"
            >
              <span class="text-white mr-3">Password:</span>
              <input
                type="password"
                class="focus:outline-none w-full md:w-3/4 text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-full px-5"
                placeholder="Enter password here"
                v-model="password"
              />
            </div>
            <div
              class="w-full md:flex justify-end items-center font-medium p-2"
            >
              <button
                class="btn focus:outline-none w-full md:w-3/4 text-lg text-white shadow px-10"
                @click="loginWithEmailAndPassword"
              >
                Login
              </button>
            </div>
          </div>
        </div>

        <div class="md:w-4/5 mx-auto text-center">
          <div class="md:ml-20">
            <div class="mx-auto w-auto block -mb-5 pb-1">
              <span class="text-center text-xs text-gray-300"
                >or login with</span
              >
            </div>
            <div class="md:flex items-center w-full mt-2">
              <div
                class="w-full md:w-1/3 px-1 pt-4 mx-1 md:border-t md:border-gray-400"
              >
                <button
                  class="appearance-none flex justify-center items-center leading-tight w-full bg-blue-800 hover:bg-blue-900 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                  type="button"
                  @click="loginWithFaceBook"
                >
                  <i class="bx bxl-facebook mr-1"></i>
                  Facebook
                </button>
              </div>
              <div class="w-full md:w-1/3 px-1 pt-4 mx-1">
                <button
                  class="appearance-none flex justify-center items-center leading-tight w-full bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                  type="button"
                  @click="loginWithGoogle"
                >
                  <i class="bx bxl-google mr-1"></i>
                  Google
                </button>
              </div>
              <div
                class="w-full md:w-1/3 px-1 pt-4 mx-1 md:border-t md:border-gray-400"
              >
                <button
                  class="appearance-none flex justify-center items-center leading-tight w-full bg-gray-500 hover:bg-gray-700 font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                  type="button"
                  @click="loginWithApple"
                >
                  <i class="bx bxl-apple mr-1"></i>
                  Apple ID
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5 md:mt-5 text-xl text-center">
          <p>
            Don’t have an account yet?
            <router-link class="text-custom" to="/signup">Sign Up</router-link>
          </p>
        </div>
      </div>
    </div>
    <Footer>Welcome</Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/layout/Nav.vue";
import Footer from "@/components/layout/Footer.vue";
import Auth from "@/providers/auth";
export default {
  name: "Login",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Login",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    loginWithEmailAndPassword() {
      Auth.loginWithEmailAndPassword(this.email, this.password)
        .then(res => {
          return this.routeBasedOnSubscriptionData(res.user.uid);
        })
        .catch(err => {
          console.log("err", err);
          this.$vToastify.error(err);
          if (err.name == "UserDoesntExist") {
            Auth.signOut(this.$router);
          }
        });
    },
    loginWithGoogle() {
      Auth.loginWithGoogle()
        .then(user => {
          return this.routeBasedOnSubscriptionData(user.uid);
        })
        .catch(err => {
          console.log("err", err);
          this.$vToastify.error(err.message);
          if (err.name == "UserDoesntExist" || err.code == "UserDoesntExist") {
            Auth.signOut(this.$router);
          }
        });
    },
    loginWithFaceBook() {
      Auth.loginWithFacebook()
        .then(user => {
          return this.routeBasedOnSubscriptionData(user.uid);
        })
        .catch(err => {
          console.log("err", err);
          this.$vToastify.error(err.message);
          if (err.name == "UserDoesntExist" || err.code == "UserDoesntExist") {
            Auth.signOut(this.$router);
          }
        });
    },
    loginWithApple() {
      Auth.loginWithApple()
        .then(user => {
          return this.routeBasedOnSubscriptionData(user.uid);
        })
        .catch(err => {
          console.log("err", err);
          this.$vToastify.error(err.message);
          if (err.name == "UserDoesntExist" || err.code == "UserDoesntExist") {
            Auth.signout();
          }
        });
    },
    routeBasedOnSubscriptionData(uid) {
      return new Promise((resolve, reject) => {
        Auth.getSubscriptionDetails(uid)
          .then(subscriptionData => {
            console.log("subscriptionData", subscriptionData);
            if (!subscriptionData) {
              this.$router.push("/user/welcome");
            } else if (
              subscriptionData &&
              subscriptionData.status != "active"
            ) {
              this.$router.push("/user/payment");
            } else {
              this.$router.push("/user/subscriptions");
            }
            this.$vToastify.success(
              "User has been signed-in successfully",
              "User SignIn success"
            );
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
</script>
